import { takeLatest, all } from 'redux-saga/effects';

import { requestAndSet, sendToHelium } from 'utils/helpers';

import { userActivityActions } from '../slices/userActivitySlice';

function* fetchUserActivitiesSaga(
  action: ReturnType<typeof userActivityActions.fetchUserActivities>,
) {
  const { orgId, startDate, endDate } = action.payload;
  yield requestAndSet('getActivityLog', [orgId], {
    queryStringParams: { startDate, endDate },
    createSetterAction: userActivityActions.setUserActivities,
    loadingAction: (v: boolean) =>
      userActivityActions.setLoading({
        key: 'fetchUserActivitiesLoading',
        value: v,
      }),
  });
}

function* fetchUserActivityTypesSaga(
  action: ReturnType<typeof userActivityActions.fetchUserActivityTypes>,
) {
  const { orgId } = action.payload;
  yield requestAndSet('getActivityType', [orgId], {
    createSetterAction: userActivityActions.setUserActivityTypes,
    loadingAction: (v: boolean) =>
      userActivityActions.setLoading({
        key: 'fetchUserActivityTypesLoading',
        value: v,
      }),
  });
}

function* logUserActivitySaga(
  action: ReturnType<typeof userActivityActions.logUserActivity>,
) {
  const { orgId, userActivity } = action.payload;
  yield sendToHelium('newActivityLog', [orgId], userActivity, {
    loadingAction: (v: boolean) =>
      userActivityActions.setLoading({
        key: 'logUserActivityLoading',
        value: v,
      }),
  });
}

export default function* userActivitySaga() {
  yield all([
    takeLatest(
      userActivityActions.fetchUserActivities.type,
      fetchUserActivitiesSaga,
    ),
    takeLatest(
      userActivityActions.fetchUserActivityTypes.type,
      fetchUserActivityTypesSaga,
    ),
    takeLatest(userActivityActions.logUserActivity.type, logUserActivitySaga),
  ]);
}
